import MobxWrap from '@/components/MobxWrap';
import { useMemo } from 'react';
import { getCloudProductConfig, hasCloudService } from '@/components/ExtraBindService/CloudServices.config';
import styles from './index.module.less';
import LazyLoadImg from '@/components/LazyLoadImg';
import InstaCheckBox from '@/components/InstaCheckBox';
import { CloudTracker } from '@/utils/Tracker';
import { formatPriceThousands } from '@/utils/configs/price.config';
import { isEmpty } from 'lodash';

/**
 * 套餐下拉的云存提示模块
 * @param {*} props
 */
const CloudWrap = (props) => {
  const { productDetail, extraService, setStateValue } = props.product;
  const { isCloudServiceActive, isMobile, isIOS, isApp } = props.app;
  const {
    commodity,
    commodity: { isOutOfStock, id: cid },
    order: { selectedCartItems },
    area: { LANG, country },
  } = props;

  // app IOS端因为存在引流云存导致发版本审核不通过，因此隐藏
  const isIOSAPP = isIOS && isApp;

  /** 云存套餐 */
  const cloudCommodity = useMemo(() => extraService?.[0] || {}, [extraService]);
  const checked = useMemo(() => {
    return cloudCommodity?.commodity?.count > 0;
  }, [cloudCommodity]);
  const cloudProductConfig = getCloudProductConfig();

  const toggleCloudCheckbox = (checked) => {
    CloudTracker.ProductPage({
      category: `${isMobile ? 'mobile' : 'pc'}_product_page_cloud_recommend`,
      action: checked ? 'bundle_rec_box_select' : 'bundle_rec_box_unselect',
      _label: cid,
    });
    cloudCommodity.commodity.count = checked ? 1 : 0;
    setStateValue('extraService', [{ ...cloudCommodity }]);
  };

  const cloudServiceVisible = useMemo(() => {
    /** 是否为能使用云存的产品 */
    const hasCloudServicePid = cloudProductConfig?.relatedProductIds.includes(productDetail?.id);
    /**
     * 满足下列条件时则展示云存服务加购栏
     * 1. 购物车中没有云存服务
     * 2. 非订阅用户
     * 3. 当前套餐不缺货
     * 4. 是否为能使用云存的产品
     */
    return (
      !isEmpty(cloudCommodity?.commodity) &&
      cloudCommodity?.commodity?.isNeedHidePrice === false &&
      hasCloudServicePid &&
      !isOutOfStock &&
      !hasCloudService(selectedCartItems) &&
      isCloudServiceActive === false
    );
  }, [
    cloudCommodity,
    cloudProductConfig?.relatedProductIds,
    isCloudServiceActive,
    isOutOfStock,
    productDetail?.id,
    selectedCartItems,
  ]);

  if (!cloudServiceVisible || isEmpty(cloudCommodity?.commodity) || isEmpty(commodity) || isIOSAPP) return null;

  return (
    <div className={styles.cloudServiceWrap}>
      <LazyLoadImg className={styles.cloudImg} src={cloudProductConfig?.thumb} />
      <div className={styles.cloudContent}>
        <div className={styles.cloudName}>
          <div>{`${cloudProductConfig?.commodity?.product_name} ${cloudProductConfig?.productPage?.cName}`}</div>
          <span className={styles.cloudRecommend}>{LANG['bindServices.productPage.recommend']}</span>
        </div>
        <div className={styles.cloudDesc}>
          <span>{LANG['bindServices.productPage.commodity_cloud_desc']}</span>
          {isMobile && (
            <InstaCheckBox
              className={styles.cloudCheckBox}
              type='black'
              checked={checked}
              onChange={toggleCloudCheckbox}
            />
          )}
        </div>
        <div className={styles.cloudPrice}>
          <div className={styles.nowPrice}>
            {formatPriceThousands({
              price: cloudProductConfig?.commodity?.price?.amount,
              signal: cloudProductConfig?.commodity?.price?.signal,
              currency: cloudProductConfig?.commodity?.price?.currency,
              country,
            })}
          </div>
          {cloudProductConfig?.commodity?.origin_price && (
            <div className={styles.originPrice}>
              {formatPriceThousands({
                price: cloudProductConfig?.commodity?.origin_price?.amount,
                signal: cloudProductConfig?.commodity?.origin_price?.signal,
                currency: cloudProductConfig?.commodity?.origin_price?.currency,
                country,
              })}
            </div>
          )}
        </div>
      </div>
      {!isMobile && (
        <InstaCheckBox className={styles.cloudCheckBox} type='black' checked={checked} onChange={toggleCloudCheckbox} />
      )}
    </div>
  );
};

export default MobxWrap(['product', 'app', 'area', 'order'], CloudWrap);
